// extracted by mini-css-extract-plugin
export default {"description":"mrnHO9","descriptionText":"_cwDpU"};